
import React from 'react';

const CheckList = (props) => {
    console.log(props);
    return( 
        <table>
            <thead>
                <tr><th>項目</th><th>入力内容</th></tr>
            </thead>
            <tbody>
                <tr><td>お名前</td><td>{props.newUser.name_kanji.s_kanji} {props.newUser.name_kanji.n_kanji}</td></tr>
                <tr><td>フリガナ</td><td>{props.newUser.name_kana.s_kana} {props.newUser.name_kana.n_kana}</td></tr>
                <tr><td>連絡先の選択</td><td>{props.newUser.contact}</td></tr>
                <tr><td>電話番号</td><td>{props.newUser.tel}</td></tr>
                <tr><td>生年月日</td><td>{props.newUser.birthday['0']}年 {props.newUser.birthday['1']}月 {props.newUser.birthday['2']}日</td></tr>
                <tr><td>郵便番号</td><td>{props.newUser.zip}</td></tr>
                <tr><td>住所</td><td>{props.newUser.addres.address0}</td></tr>
                <tr><td></td><td>{props.newUser.addres.address3}</td></tr>
                <tr><td>メール</td><td>{props.newUser.mail}</td></tr>
                <tr><td>HTMLメール不可</td><td>{props.newUser.html_mail.toString()}</td></tr>
                <tr><td>性別</td><td>{props.newUser.sex}</td></tr>
                <tr><td>ご希望の地域1</td><td>{props.newUser.area_1}</td></tr>
                <tr><td>ご希望の地域2</td><td>{props.newUser.area_2}</td></tr>
                <tr><td>ご希望の地域3</td><td>{props.newUser.area_3}</td></tr>
                <tr><td>現在のお住まい</td><td>{props.newUser.current_type}</td></tr>
                <tr><td>ご検討理由</td><td>{props.newUser.reason}</td></tr>
                <tr><td>ご入居予定人数</td><td>{props.newUser.members}</td></tr>
                <tr><td>駐車場必要台数</td><td>{props.newUser.parking}</td></tr>
                <tr><td>ご購入予定時期</td><td>{props.newUser.time_limit}</td></tr>
                <tr><td>ご購入予算</td><td>{props.newUser.cost}</td></tr>
                <tr><td>ご希望間取り</td><td>{props.newUser.floor_plan}</td></tr>
            </tbody>
        </table>
    )
}
    
export default CheckList;